/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DeviceRegistrationRequestDTO } from './DeviceRegistrationRequestDTO';

export type VerifyOtpDTO = {
    channel?: VerifyOtpDTO.channel;
    countryCode?: VerifyOtpDTO.countryCode;
    deviceInfo?: DeviceRegistrationRequestDTO;
    email?: string | null;
    externalAccountPhoneNumber?: string;
    phoneNumber?: string;
    purpose?: VerifyOtpDTO.purpose;
    /**
     * Onboarding session the verification belongs to. Supplied by callers that are not authenticated and whose contact value cannot be resolved back to a session - a corporate business email or business phone, for instance.
     */
    userExternalId?: string | null;
    verificationCode?: string;
};

export namespace VerifyOtpDTO {

    export enum channel {
        WEB = 'WEB',
        MOBILE = 'MOBILE',
        POS = 'POS',
    }

    export enum countryCode {
        NG = 'NG',
        GH = 'GH',
    }

    export enum purpose {
        SIGN_IN = 'SIGN_IN',
        NON_CUSTOMER_SIGN_UP = 'NON_CUSTOMER_SIGN_UP',
        CUSTOMER_SIGN_UP = 'CUSTOMER_SIGN_UP',
        TRANSACTION_PIN = 'TRANSACTION_PIN',
        CHANGE_PROFILE = 'CHANGE_PROFILE',
        CHANGE_PROFILE_PASSWORD = 'CHANGE_PROFILE_PASSWORD',
        TWO_FACTOR = 'TWO_FACTOR',
        MISMATCH_SIGN_UP = 'MISMATCH_SIGN_UP',
        CHANGE_OF_DEVICE = 'CHANGE_OF_DEVICE',
        SECURE_TRANSACTION = 'SECURE_TRANSACTION',
        UPDATE_EMAIL = 'UPDATE_EMAIL',
        UPDATE_PHONE = 'UPDATE_PHONE',
        EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
        PHONE_VERIFICATION = 'PHONE_VERIFICATION',
        EMAIL_SETUP = 'EMAIL_SETUP',
        TEAM_MEMBER_INVITE = 'TEAM_MEMBER_INVITE',
        DIRECTOR_VERIFICATION = 'DIRECTOR_VERIFICATION',
        RISK_CHALLENGE = 'RISK_CHALLENGE',
    }


}
